import { saveUserData, fetchUserData, getKindeInstance } from './kindeClient';
import { verifyAccessCode, checkUsernameUnique, verifyBoostCode } from './verification';
import { updateStats } from '../ui/stats';
import { initializeGame } from '../gameplay/game';
import { showUsernameModal, hideAllModals } from '../ui/modals';
import { getUser, displayLoggedInView } from '../ui/views';
import { showAppLoader } from '../ui/loader';

const setUsername = async (username) => {
    const user = getUser();
    console.log(`Setting username to ${username}`);
    if (!user) {
        throw new Error('Not signed in. Please refresh and try again.');
    }
    // If the user already has this exact name saved server-side, skip the
    // uniqueness check (it would falsely report "taken" on their own name).
    if (user.username && user.username === username) {
        await finishUsername(user, username);
        return;
    }
    const isUnique = await checkUsernameUnique(username);
    if (!isUnique) {
        throw new Error('That username is already taken.');
    }
    await finishUsername(user, username);
};

async function finishUsername(user, username) {
    const previousUsername = user.username || '';
    user.username = username;
    showAppLoader('Saving your name…', 'username');
    // Single attempt — retrying doubled cold-start latency for users
    // who would have to wait again anyway. The error path lets them
    // hit the button again themselves.
    const result = await saveUserData();
    if (!result || !result.ok) {
        // Roll back the local change so the user can retry without the
        // "matches existing username" short-circuit kicking in.
        user.username = previousUsername;
        throw new Error(
            (result && result.error && result.error.message) ||
            'Could not save your username. Please try again.'
        );
    }
    const display = document.getElementById('usernameDisplay');
    if (display) display.textContent = `${user.username}`;
    hideAllModals();
    document.getElementById('overlay').style.display = 'none';

    // If the lobby's already up (we're just renaming), don't re-init the
    // game — that would re-attach listeners, restart music, etc. Only do
    // the full lobby boot for first-time setup.
    const loggedInView = document.getElementById('logged_in_view');
    const lobbyAlreadyVisible = loggedInView && loggedInView.style.display === 'block';
    if (lobbyAlreadyVisible && previousUsername) {
        return;
    }
    showAppLoader('Loading game…', 'game');
    requestAnimationFrame(() => displayLoggedInView());
}

const setAccessCode = (accessCode) => {
    const user = getUser(); // Get the current user state
    console.log(`Setting access code to ${accessCode}`);
    verifyAccessCode(accessCode).then(isValid => {
        if (isValid) {
            console.log(`Saving Access Code: ${accessCode}`);
            user.accessCode = accessCode;
            saveUserData();
            hideAllModals();
            document.getElementById('overlay').style.display = 'none';
            initializeGame();
        } else {
            alert('Invalid or already used Access Code. Please enter a valid code.');
        }
    }).catch(error => {
        console.error('Error verifying Access Code:', error);
        alert('Error verifying Access Code. Please try again.');
    });
};

const setBoostCode = async (boostCode) => {
    const user = getUser(); // Get the current user state
    console.log(`Setting boost code to ${boostCode}`);
    try {
        const result = await verifyBoostCode(boostCode);
        console.log('Server response:', result);

        console.log(`Boost Code Applied: ${boostCode}`);
        console.log(`Rewards: Coins: ${result.rewards.coins}, Gems: ${result.rewards.gems}, Mana: ${result.rewards.mana}`);

        user.boostCode = boostCode;
        user.coins = (user.coins || 0) + result.rewards.coins;
        user.gems = (user.gems || 0) + result.rewards.gems;
        user.mana = (user.mana || 0) + result.rewards.mana;

        saveUserData();
        updateStats(user.mana, user.coins, user.gems);
        hideAllModals();
        document.getElementById('overlay').style.display = 'none';

        alert(`Boost code applied! You received ${result.rewards.coins} coins, ${result.rewards.gems} gems, and ${result.rewards.mana} mana.`);

    } catch (error) {
        console.error('Error verifying boost code:', error);
        if (error.message.includes('already been used by you')) {
            alert('You have already used this boost code.');
        } else if (error.message.includes('already been used by another user')) {
            alert('This boost code has already been used by another user.');
        } else {
            alert('Invalid or already used boost code. Please enter a valid code.');
        }
    }
};


export { setUsername, setAccessCode, setBoostCode };
